import { RequestDataDto } from "@app/core/dto/request-data.dto";
import { ActionCommand } from "../action-command-interface";
import { ActionCommandResponseDto } from "@app/core/dto/action-command-response.dto";

export class ShareCommand implements ActionCommand {
  constructor(private renderEngineComponent: any) { }

  async execute(actionData: any, requestData: RequestDataDto): Promise<ActionCommandResponseDto> {
    const payload = { ...actionData?.params };
    const shareUrl: string = `${payload.url}${this.renderEngineComponent.router.url}`;
    window.open(shareUrl ?? '/', '_self');
    return
  }
}